/**
 * 报警一览页面
 * 创建时间：2017-03-29
 * 创建人：masonchen
 * 修改人：baixx
 */
<template>
<div class="wrapper-content fadeInRight animated tabBox" id="alarmhandle-list">
    <div class="ibox-content" v-loading="loadingstatus" element-loading-text="加载中">	   	
		<!--表单查询开始-->
		<div class="form-horizontal pt10px">
			<div class="form-group">
				<label class="col-sm-1 control-label">报警类型</label>
				<div class="col-sm-2">
					<select class="form-control" v-model="queryParam.almType">
						<option v-for="option in alarmTypeList" v-bind:value="option.udccode">
							{{ option.udcname }}
						</option>
					</select>
				</div>
				<label class="col-sm-1 control-label">紧急度</label>
				<div class="col-sm-2">
					<select class="form-control" v-model="queryParam.almLevel">
						<option v-for="option in alarmLevelList" v-bind:value="option.udccode">
							{{ option.udcname }}
						</option>
					</select>
				</div>
				<label class="col-sm-1 control-label">报警开始时间</label>
				<div class="col-sm-2" v-bind:class="{ 'form-group--error': !validDates }">
					<datepicker v-model="queryParam.almTimeStart" class="form-control" ref="alarmStartFrom"></datepicker>
					<p v-if="!validDates" class="cus_message form-group__message">开始时间不得大于结束时间</p>
				</div>
				<label class="col-sm-1 control-label">报警结束时间</label>
				<div class="col-sm-2" v-bind:class="{ 'form-group--error': !validDates }">
					<datepicker v-model="queryParam.almTimeEnd" class="form-control" ref="alarmEndFrom"></datepicker>
					<p v-if="!validDates" class="cus_message form-group__message">开始时间不得大于结束时间</p>
				</div>
			</div>
			<div class="form-group">
				<label class="col-sm-1 control-label">车辆ID</label>
				<div class="col-sm-2">
					<input class="form-control" v-model.trim="queryParam.vehicleId" maxlength="10">
				</div>                          
				<label class="col-sm-1 control-label">服务号</label>
				<div class="col-sm-2">
					<input type="text" class="form-control" v-model.trim="queryParam.vehicleAccount" maxlength="20">
				</div>
				<label class="col-sm-1 control-label">处理开始时间</label>
				<div class="col-sm-2" v-bind:class="{ 'form-group--error': !validManageDates }">
					<datepicker v-model="queryParam.handleTimeStart" class="form-control" ref="manageStartFrom"></datepicker>
					<p v-if="!validManageDates" class="cus_message form-group__message">开始时间不得大于结束时间</p>
				</div>
				<label class="col-sm-1 control-label">处理结束时间</label>
				<div class="col-sm-2" v-bind:class="{ 'form-group--error': !validManageDates }">
					<datepicker v-model="queryParam.handleTimeEnd" class="form-control" ref="manageEndFrom"></datepicker>
					<p v-if="!validManageDates" class="cus_message form-group__message">开始时间不得大于结束时间</p>
				</div>
			</div>
			<div class="form-group">
			    <label class="col-sm-1 control-label">车牌号</label>
				<div class="col-sm-2">
					<vplate-input type="text" class="form-control" v-model.trim="queryParam.plateNumber" maxlength="7"/>
				</div>
				 <label class="col-sm-1 control-label">报警号</label>
				<div class="col-sm-2">
					<input type="text" class="form-control" v-model.trim="queryParam.almId">
				</div>
				<!--<label class="col-sm-1 control-label">处理人</label>
				<div class="col-sm-2">
					<input type="text" class="form-control" v-model="queryParam.handleId">
				</div>-->
			</div>
			<div class="form-group">
				<div class="col-sm-12 text-right">
					<button type="button" v-if="permission.indexOf('alarmHandleList_reset') == -1" class="btn btn-primary" @click="resetQueryParams">重置</button>
					<button type="button" v-if="permission.indexOf('alarmHandleList_select') == -1" class="btn btn-primary" @click="searchInfo" :disabled="!validDates ||!validManageDates">查询</button>
				</div>
			</div>
		</div>
		<!--表单查询结束-->
		<div class="hr-line-dashed"></div>
		<!--表格开始-->
		<table class="table mt20px table-striped table-bordered">
			<thead>
				<tr>
					<th>序号</th>
					<th>报警号</th>
					<th>报警类型</th>
					<th>紧急度</th>
					<th>报警时间</th>
					<th>车辆ID</th>
					<th>服务号</th>
					<th>车牌号</th>
					<!--<th>报警内容</th>-->
					<th>处理人</th>
					<th>处理时间</th>
					<!--<th>处理方式</th>-->
					<th>处理结果</th>
					<th>报警详情</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(fileInfo,index) in orgList" v-bind:key="index">
					<td>{{index+1}}</td>
					<td>AL{{fileInfo.id}}</td>
					<td>{{fileInfo.almTypeName}}</td>
					<td>{{fileInfo.almLevelName}}</td>
					<td>{{fileInfo.almTime}}</td>
					<td>VE{{fileInfo.vehicleId}}</td>
					<td>{{fileInfo.vehicleAccount}}</td>
					<td>{{fileInfo.plateNumber}}</td>
					<!--<td>{{fileInfo.almMessage}}</td>-->
					<td>{{fileInfo.handleName}}</td>
					<td>{{fileInfo.handleTime}}</td>
					<!--<td>{{fileInfo.handleTypeName}}</td>-->
					<td >{{fileInfo.handleResult}}</td>
					<td >{{fileInfo.almMessage}}</td>
					<td class="text-center">
						<a v-if="fileInfo.handleStatus==1&&permission.indexOf('alarmHandleList_search') == -1" @click="handle(index,true)">查看</a>
						<a v-if="fileInfo.handleStatus==0&&permission.indexOf('alarmHandleList_handle') == -1" @click="handle(index,false)">处理</a>
					</td>
				</tr>
			</tbody>
		</table>
		<!--分页组件开始-->
		<pagination v-if="orgList.length>0" :pageInfo="pageInfo" v-on:getData="getPageNo"></pagination>
		<!--分页组件结束-->
		<sub-page :show="showSubPage" 
			bigTitleMsg="报警处理" 
			v-on:cancel="closeSubPage" 
			:scroll="scrollTop">
			<div slot="bodycontent">
				<page-alarm-handle-edit 
					:data="detailInfo"
					:isDetailMode="isDetailMode"
					v-on:cancel="closeSubPage"
					v-on:handleSave="saveSubPage">
				</page-alarm-handle-edit>
			</div>
		</sub-page>
		<!--弹出框子组件-->
		<tab-modal ref="modalMsg" size="small" :scroll='scrollTop' title="提示" v-on:cancel="closeModalMsg">
			{{messageStr}}
			<div slot="footer">
		        <button @click="closeModalMsg" class="btn btn-primary">确定</button>
		    </div>
		</tab-modal>
	</div>
</div>	
</template>
<script>
	import {DICTIONARY_MAP} from 'static/constant'
	import SubPage from 'components/common/SubPage'
	import Pagination from 'components/common/Pagination'
	import PageAlarmHandleEdit from 'components/pages/alarmhandle/PageAlarmHandleEdit'
	import Datepicker from 'components/common/datepicker/Datepicker'
	import { OPERATE_SUCCESS, OPERATE_EXCEPTION } from 'static/message'
	import TabModal from 'components/common/TabModal'
	import {getDictionaryFromArray} from 'util/util'
	import {mapState} from 'vuex'
	import classlist from 'util/classlist'
	
	export default {
		name: "PageAlarmHandleList",
		components: {
			Pagination,
			SubPage,
			PageAlarmHandleEdit,
			Datepicker,
			TabModal
		},
		data() {
			return {
				permission:this.$store.state.permission.permission["alarmHandleList"]?this.$store.state.permission.permission["alarmHandleList"]:[],
				loadingstatus:false,
				showSubPage: false,
				pageInfo:{},	                                        //分页所需信息
				orgList: [], 		                                    //表格数据列表
				messageStr: "",					                        // 弹出框内容
				scrollTop: '',
				detailInfo:{},											//报警详情对象
				queryParam:{			
					planOwnerType:1,
				    almLevel: "",										// 报警等级
					almTimeStart: "",							        // 报警起始时间
					almTimeEnd: "",                                     // 报警结束时间
					almType: "",		                                // 报警类型
					handleId: "",		                                // 处理人
					handleStatus: "",		                            // 处理状态
					handleTimeStart: "",		                        // 处理起始时间
					handleTimeEnd: "",		                            // 处理结束时间
					plateNumber: "",		                            // 车牌号
					vehicleAccount: "",		                            // 服务卡号
					vehicleId: "",		                                // 车辆id
					page_index: 1,                                      // 当前第几页
					almId:"",                                           //报警号
				},
				alarmTypeList:[],										// 报警类型列表
				alarmLevelList:[],										// 报警级别列表
				isDetailMode:false
			};
		},
		computed: {
			...mapState({
				almtype:state=>state.alarm.almtype,
				almlevel:state=>state.alarm.almlevel
			}),
			//起止时间是否合法
			validDates: function(){
				if(this.queryParam.almTimeStart && this.queryParam.almTimeEnd && this.queryParam.almTimeStart > this.queryParam.almTimeEnd){
					return false;
				} else {
					return true;
				}
			},
			//处理时间是否合法
			validManageDates: function(){
				if(this.queryParam.handleTimeStart && this.queryParam.handleTimeEnd && this.queryParam.handleTimeStart > this.queryParam.handleTimeEnd){
					return false;
				} else {
					return true;
				}
			}
		},
		beforeMount() {
			this.queryParam.almType=this.$store.state.alarm.almtype;
			this.queryParam.almLevel=this.$store.state.alarm.almlevel;
			this.getTableInfo();
			this.getUdc();
		},
		watch: {
			almtype:function(val){
				this.queryParam.page_index = 1;
				this.queryParam.almType=val;
				this.queryParam.almLevel='';
				this.getTableInfo();
			},
			almlevel:function(val){
				this.queryParam.page_index = 1;
				this.queryParam.almType='';
				this.queryParam.almLevel=val;
				this.getTableInfo();
			}
		},
		methods: {
			//查询方法
			searchInfo(){
				this.queryParam.page_index = 1;
				this.getTableInfo();
			},
			// 获取列表信息
			getTableInfo() { 
				this.loadingstatus = true;
				this.$http.get(process.env.API_ROOT + '/alarm/alarms', {params: this.queryParam})
					.then( res => {
						if(res.body.success){
							const resInfo = res.body.data;								
							const {pageNum,pages,total,isFirstPage,isLastPage} = resInfo;
							this.pageInfo = {
								pageNum: pageNum,
								pages: pages,
								total: total,
								isFirstPage: isFirstPage,
								isLastPage: isLastPage
							}
							this.orgList = resInfo.list;
							this.loadingstatus = false;
						} else {
							this.openModalMsg(res.body.message);
							this.loadingstatus = false;
						}
					}, res => {
						this.openModalMsg(res.body.message);
						this.loadingstatus = false;
					}).catch( res => {
						this.openModalMsg(OPERATE_EXCEPTION);
						this.loadingstatus = false;
				})
			},
			//重置信息
			resetQueryParams:function(){
				this.$refs.alarmStartFrom.handleClear();
				this.$refs.alarmEndFrom.handleClear();
				this.$refs.manageStartFrom.handleClear();
				this.$refs.manageEndFrom.handleClear();
				this.queryParam = {
					almLevel: "",										// 报警等级
					almTimeStart: "",							        // 报警起始时间
					almTimeEnd: "",                                     // 报警结束时间
					almType: "",		                                // 报警类型
					handleId: "",		                                // 处理人
					handleStatus: "",		                            // 处理状态
					handleTimeStart: "",		                        // 处理起始时间
					handleTimeEnd: "",		                            // 处理结束时间
					plateNumber: "",		                            // 车牌号
					vehicleAccount: "",		                            // 服务卡号
					vehicleId: "",		                                // 车辆id
					page_index: 1,                                      // 当前第几页
					almId:"",                                           //报警号
				}
			},
			getUdc(){
				let udcType = [
					DICTIONARY_MAP.ALARM_TYPE,
					DICTIONARY_MAP.ALM_LEVEL,
				]
				let param = udcType.join(',');
				this.$http.get(process.env.API_ROOT + '/system/udcs',{params:{udcTypes: param}})
				.then(res => {
					if(res.data.success){	
					 	this.alarmTypeList = getDictionaryFromArray(res.data.data,DICTIONARY_MAP.ALARM_TYPE);
						this.alarmLevelList = getDictionaryFromArray(res.data.data,DICTIONARY_MAP.ALM_LEVEL);
					}else{
						this.$parent.openModal(res.data.message);
					}
				}, res => {
					this.$parent.openModal(res.data.message);
				}).catch( res => {
					this.$parent.openModal(OPERATE_EXCEPTION);
				})		
			},
			//从分页组件获取页码参数
			getPageNo(param) {
				this.queryParam.page_index = param;
				this.getTableInfo();
			},
			// 点击处理
			handle(index,isDetailMode){
				this.detailInfo = Object.assign({},this.orgList[index]);
				this.isDetailMode = isDetailMode;
				this.showSubPage = true;
				classlist.toggleScroll('close','#alarmhandle-list',this);
			},
			closeSubPage(){
				this.showSubPage = false;
				classlist.toggleScroll('open','#alarmhandle-list',this);
			},
			// 消息弹出框相关 
			openModal(ref) {
            	this.$refs[ref].open();
            	classlist.toggleScroll('close','#alarmhandle-list',this);
        	},
        	closeModal(ref){
        		this.$refs[ref].close();
        		classlist.toggleScroll('open','#alarmhandle-list',this);
        	},
        	closeModalMsg(){
        		this.closeModal("modalMsg");
        	},
        	openModalMsg(message){
        		this.messageStr = message;
        		this.openModal("modalMsg")
        	},
        	/*保存报警处理成功*/
			saveSubPage(almLevel){
				this.getTableInfo();
				this.closeSubPage();
			}
		}
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// PageAlarmHandleList.vue?16e71363